// src/Redux/Reducer/PurchaseReducer.js - UPDATED
const initialState = {
  purchaseOrders: [],
  selectedOrder: null,
  loading: false,
  actionLoading: false,
  error: null,
  total: 0,
  wastageReport: [],
  purchaseWastageDetails: []
};

const PurchaseReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch Purchase Orders
    case 'FETCH_PURCHASES_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_PURCHASES_SUCCESS':
      return { 
        ...state, 
        loading: false, 
        purchaseOrders: action.payload.orders || action.payload, 
        total: action.payload.total || 0,
        error: null 
      };
    case 'FETCH_PURCHASES_FAILURE':
      return { ...state, loading: false, error: action.payload };

    // Get Purchase Order by ID
    case 'GET_PURCHASE_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'GET_PURCHASE_SUCCESS':
      return { ...state, actionLoading: false, selectedOrder: action.payload, error: null };
    case 'GET_PURCHASE_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    // Create Purchase Order
    case 'CREATE_PURCHASE_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'CREATE_PURCHASE_SUCCESS':
      return { 
        ...state, 
        actionLoading: false, 
        // purchaseOrders: [action.payload.order || action.payload, ...state.purchaseOrders],
        error: null 
      };
    case 'CREATE_PURCHASE_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    // Update Purchase Order
    case 'UPDATE_PURCHASE_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'UPDATE_PURCHASE_SUCCESS':
      return { 
        ...state, 
        actionLoading: false,
        purchaseOrders: state.purchaseOrders.map(o => 
          o.id === action.payload.id ? action.payload : o
        ),
        selectedOrder: action.payload,
        error: null 
      };
    case 'UPDATE_PURCHASE_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    // Update Status
    case 'UPDATE_PURCHASE_STATUS_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'UPDATE_PURCHASE_STATUS_SUCCESS':
      return { 
        ...state, 
        actionLoading: false,
        purchaseOrders: state.purchaseOrders.map(o => 
          o.id === action.payload.id ? { ...o, status: action.payload.status } : o
        ),
        error: null 
      };
    case 'UPDATE_PURCHASE_STATUS_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    // Receive Purchase Order
    case 'RECEIVE_PURCHASE_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'RECEIVE_PURCHASE_SUCCESS':
      return { 
        ...state, 
        actionLoading: false,
        purchaseOrders: state.purchaseOrders.map(o => 
          o.id === action.payload.id ? action.payload : o
        ),
        error: null 
      };
    case 'RECEIVE_PURCHASE_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    // Delete Purchase Order
    case 'DELETE_PURCHASE_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'DELETE_PURCHASE_SUCCESS':
      return { 
        ...state, 
        actionLoading: false,
        purchaseOrders: state.purchaseOrders.filter(o => o.id !== action.payload),
        error: null 
      };
    case 'DELETE_PURCHASE_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    // Wastage Report
    case 'FETCH_WASTAGE_REPORT_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_WASTAGE_REPORT_SUCCESS':
      return { 
        ...state, 
        loading: false, 
        wastageReport: action.payload,
        error: null 
      };
    case 'FETCH_WASTAGE_REPORT_FAILURE':
      return { ...state, loading: false, error: action.payload };

    // Purchase Wastage Details
    case 'FETCH_PURCHASE_WASTAGE_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_PURCHASE_WASTAGE_SUCCESS':
      return { 
        ...state, 
        loading: false, 
        purchaseWastageDetails: action.payload,
        error: null 
      };
    case 'FETCH_PURCHASE_WASTAGE_FAILURE':
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default PurchaseReducer;